import { create, StateCreator } from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import type { SalesStoreState, Customer, CountriesRecord } from '../types'

// ─── Types ────────────────────────────────────────────────────────────────────

interface SalesStoreActions {
   setCustomers: (list: Customer[]) => void
   setCountries: (list: CountriesRecord) => void
   setChecksumCountries: (val: string | null) => void
   setLastUpdatedCustomers: (val: string | null) => void
   setLastUpdatedVentesRAL: (val: string | null) => void
   setLastUpdatedConfies: (val: string | null) => void
   setLastUpdatedConfiesRAL: (val: string | null) => void
   setLastUpdatedBiOrders: (val: string | null) => void
   setLastUpdatedOrders: (val: string | null) => void
   setLocalDataVersion: (name: string, version: number) => void
}

type SalesStore = SalesStoreState & SalesStoreActions

// ─── Store ────────────────────────────────────────────────────────────────────

const salesStore: StateCreator<SalesStore> = (set) => ({
   customers: [],
   countries: {},

   // Checksum du dernier fetch valide
   checksum_countries: null,

   // Date+heure de dernière modification dans AppWrite
   last_updated_customers: null,
   last_updated_ventes_ral: null,
   last_updated_confies: null,
   last_updated_confies_ral: null,
   last_updated_bi_orders: null,
   last_updated_orders: null,

   // Version des données locales par collection (cf. src/libs/localDataVersion.ts)
   local_data_versions: {},

   setCustomers: (list) => set(() => ({ customers: list })),

   setCountries: (list) => set(() => ({ countries: list })),

   setChecksumCountries: (val) => set(() => ({ checksum_countries: val })), // Bugfix: was writing to checksum_collections (models store)

   setLastUpdatedCustomers: (val) => set(() => ({ last_updated_customers: val })),

   setLastUpdatedVentesRAL: (val) => set(() => ({ last_updated_ventes_ral: val })),

   setLastUpdatedConfies: (val) => set(() => ({ last_updated_confies: val })),

   setLastUpdatedConfiesRAL: (val) => set(() => ({ last_updated_confies_ral: val })),

   setLastUpdatedBiOrders: (val) => set(() => ({ last_updated_bi_orders: val })),

   setLastUpdatedOrders: (val) => set(() => ({ last_updated_orders: val })),

   setLocalDataVersion: (name, version) => set((state) => ({ local_data_versions: { ...state.local_data_versions, [name]: version } }))
})

const useSalesStore = create<SalesStore>()(devtools(persist(salesStore, { name: 'sales' })))

export default useSalesStore
export type { SalesStore, SalesStoreActions }
